<template>
    <svg class="icon"
         aria-hidden="true">
        <use :xlink:href="`#${id}`"></use>
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        id: String
    }
};
</script>
